const path = "/pedagogico/avaliacao-institucional";
export default {
  validarUsuario: `${path}/validar`,
  questionariosServidores: `${path}/questionarios-servidores`,
};
